import { useSearchParams } from 'react-router'

import { SUBMENU_PARAM_KEY } from '../../../constants/route'
import { SubMenuList } from '../SubMenuList'
import { SubMenuWrapper } from '../SubMenuWrapper'

import {
  SUBMENU_ITEM_KEYS,
  SUBMENU_UNREAD_KEYS,
} from './SubMenuDefault.constants'

import * as styles from './SubMenuDefault.module.css'

function SubMenuDefault({ count, menuTitle, show, subMenu }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const sub = searchParams.get(SUBMENU_PARAM_KEY)

  function handleClick(value) {
    if (sub === value) {
      return
    }

    setSearchParams({ [SUBMENU_PARAM_KEY]: value })
  }

  function isActive(item) {
    return sub === item.name
  }

  if (subMenu.items.length === 0 || !show) {
    return null
  }

  const counts = {
    [SUBMENU_UNREAD_KEYS.all]: count,
    [SUBMENU_UNREAD_KEYS.unread]: count,
  }

  return (
    <SubMenuWrapper className={styles.subMenuDefault}>
      <span className={styles.subTitle}>{menuTitle}</span>
      <SubMenuList
        apiKeys={SUBMENU_ITEM_KEYS}
        counts={counts}
        isActive={isActive}
        items={subMenu.items}
        onClickItem={handleClick}
      />
    </SubMenuWrapper>
  )
}

export default SubMenuDefault
